import React, { useEffect, useState } from 'react'
import { Select, MenuItem } from '@mui/material';
import { useProveedorCompany } from '../../components';

const SelectBranchs = ({ color = 'auto' }) => {
    const {
        currentBranch,
        setCurrentBranch,
        arrayBranchs,
    } = useProveedorCompany();

    const [select_val, setSelect_val] = useState(null);

    function handleBranchSelected(event) {
        const newSelected = event.target.value;
        const updateCurrentBranch = (arrayBranchs ?? []).find((objs) => objs?.key_branch == newSelected);
        setSelect_val(newSelected);
        setCurrentBranch(updateCurrentBranch);
    }

    return (
        <Select
            style={{ color: color == 'auto' ? '#000' : color }}
            labelId="store-select-label"
            value={select_val ?? currentBranch?.key_branch}
            onChange={handleBranchSelected}
            sx={{
                '.MuiOutlinedInput-notchedOutline': {
                    borderColor: color,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: color,
                },
            }}
        >
            {
                arrayBranchs && arrayBranchs.map((objs, index) => {
                    return (
                        <MenuItem key={objs?.key_branch} value={objs?.key_branch}>{objs?.fullName}</MenuItem>
                    );
                })
            }
        </Select>
    )
}

export default SelectBranchs;